/** Do not add english translations here, unless key-value are not the same */
const en: { [key: string]: string } = {
  // These keys are SYNTHESIZED from an enum value — `Ticket state ${state}` —
  // so the key is not English prose and English cannot fall back to it. Without
  // these, the chips read "Ticket state PENDING" in every support table.
  //
  // This is the exception the note above carves out: key and value genuinely
  // differ. The alternative — keying on the display text — would mean the enum
  // value no longer appears in the key, so a value added service-side would
  // silently render blank instead of loudly rendering its own name.
  'Ticket state NEW': 'New',
  'Ticket state OPEN': 'Open',
  'Ticket state PENDING': 'Pending',
  'Ticket state RESOLVED': 'Resolved',
  'Ticket state CLOSED': 'Closed',

  'Ticket comment scope PARTICIPANT_PUBLIC': 'Visible to ticket participants',
  'Ticket comment scope ADOTEL_INTERNAL': 'Internal Adotel note',
  'Ticket comment scope REPORTER_AND_ASSIGNEE_ONLY':
    'Reporter and assignee only',

  'Diagnostic context PENDING': 'Context pending',
  'Diagnostic context RESOLVING': 'Context resolving',
  'Diagnostic context RESOLVED': 'Context attached',
  'Diagnostic context UNAVAILABLE': 'Context unavailable',
  'Diagnostic context NOT_FOUND': 'No context found',

  // Prose keys, not synthesized ones — grouped apart from the enum blocks
  // above, which the header comment describes as the deliberate exception.
  Breaching: 'Breaching',
  '{shown} of {loaded} loaded': '{shown} of {loaded} loaded',
  'No loaded tickets match this filter.':
    'No loaded tickets match this filter.',
  'No actions available from {state}.': 'No actions available from {state}.',
  'Describe what changed or what you found. Ctrl or Cmd + Enter sends.':
    'Describe what changed or what you found. Ctrl or Cmd + Enter sends.',
  // A key, not prose: the list separator differs by script — Persian uses
  // ، (U+060C). Hardcoding ", " in JS put it beyond any translator's reach.
  LIST_SEPARATOR: ', ',
  Actions: 'Actions',
  'Updating ticket…': 'Updating ticket…',
  'Ticket is now': 'Ticket is now',
  'Escalate when Adotel needs to look at this.':
    'Escalate when Adotel needs to look at this.'
}
export default en
